// Copyright (c) Hamilton Manufacturing Corp.
import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { EUG, generateId } from '../../_common/api/utility';
import { useGlobalState } from '../../_common/globalState/GlobalStateProvider';
import Loading from '../../_common/Loading';
import Button from '../../_common/form/Button';
import Card from '../Card';
import LocationDropdown from '../LocationDropdown';
import WalletCard from '../WalletCard';
import WashClub from '../WashClub';
import TimeBank from '../TimeBank';
import { currency } from '../../_common/api/utility';
import RequireFeature, { Features } from '../../_common/RequireFeature';
import AddChild from '../../_common/AddChild';

const SuspendedWashClubAlert = ({ error, onAddChild, canAddChild }) => (
    <Card title={<span style={{ color: '#c62828' }}>Wash Club Alert</span>} icon='exclamationTriangle' collapsible>
        <p>Your wash club access is currently suspended.</p>
        {error ? <p>Reason: {error}</p> : null}

        {canAddChild ? <Button onClick={onAddChild}>Add Child</Button> : null}
    </Card>
);

const Wallet = () => {
    const {
        state: {
            active_user,
        },
        setUserWallet,
        getWashClub,
        getUser
    } = useGlobalState();

    const [wallet, setWallet] = useState(null);
    const [shownWallet, setShownWallet] = useState(null);
    const [addChildRequestId, setAddChildRequestId] = useState(0);

    const { search } = useLocation();
    const navigate = useNavigate();
    const location = new URLSearchParams(search);
    const [locFilter, setLocFilter] = useState(location.get('location') || active_user.forcedLocation || 0);

    useEffect(() => {
        if (!active_user.isLoggedIn) {
            setWallet(active_user.wallet || []);
            return;
        }
        setUserWallet()
            .then((res) => {
                setWallet([...res]);
            })
            .catch(() => {
                setWallet(active_user.wallet || []);
            });
        getWashClub();
        getUser();
    }, []);

    useEffect(() => {
        if (!wallet) return;
        const items = parseInt(locFilter) !== 0 ? wallet.filter(e => e.locations.length === 0 || ~e.locations?.indexOf(parseInt(locFilter))) : wallet;
        let shown = {};
        items
            .sort((a, b) => new Date(b.purchasedDate) - new Date(a.purchasedDate))
            .forEach(e => {
                shown[e.label] ?
                    shown[e.label].push(e) :
                    shown[e.label] = [e];
            });

        if (shown.DollarDiscItem) {
            if (!shown.DollarDiscTrans) shown.DollarDiscTrans = [];
            shown.DollarDiscTrans = [...shown.DollarDiscTrans, ...shown.DollarDiscItem];
            delete shown.DollarDiscItem;
        }

        setShownWallet(
            Object
                .entries(shown)
                .map(([key, val]) =>
                    <Card title={`${key} (${val.length})`} icon={EUG(key)} collapsible key={generateId()}>
                        {val.map(e => <WalletCard key={generateId()} {...e} />)}
                    </Card>
                )
        );
    }, [locFilter, wallet]);

    if (!shownWallet) return <Loading />;

    const washClubInLocation = active_user.washClub && (parseInt(locFilter) === 0 || active_user.washClub.locations.length === 0 || ~active_user.washClub.locations?.indexOf(parseInt(locFilter)));
    const hasActiveWashClub = active_user.washClub && (active_user.washClub.status === 'Active' || active_user.washClub.status === 'EndBillingPending');
    const hasSuspendedWashClub = active_user.washClub && active_user.washClub.status === 'Suspended';
    const canAddChild = !!active_user.washClub && !active_user.washClub.parent;
    const handleAddChild = () => setAddChildRequestId((current) => current + 1);

    return (
        <>
            {addChildRequestId > 0 ? <AddChild key={addChildRequestId} /> : null}
            <LocationDropdown locFilter={locFilter} setLocFilter={setLocFilter} />
            <RequireFeature requiredFeatures={Features.AppCredit}>
                {active_user.account && active_user.account.giftBalance > 0 && (
                    <Card title='App Credit' icon='creditCard'>
                        <span>Balance: {currency.format(active_user.account.giftBalance)}</span>
                        <Button onClick={() => navigate('/appCredit')}>Reload</Button>
                        <Button onClick={() => navigate('/airPay?appCredit=true')}>Use App Credit</Button>
                    </Card>
                )}
            </RequireFeature>
            {/* {wallet.find(e => e.isGift) ? <Firework /> : null} */}
            {hasActiveWashClub && washClubInLocation ? <WashClub onAddChild={handleAddChild} /> : null}
            {hasSuspendedWashClub && washClubInLocation ? <SuspendedWashClubAlert error={active_user.washClub.error} onAddChild={handleAddChild} canAddChild={canAddChild} /> : null}

            {shownWallet}
            {(active_user.account && active_user.account.value && active_user.account.value.timeBanks.length > 0) ?
                <RequireFeature requiredFeatures={Features.TimeProducts}>
                    <Card title='Time Bank' icon='clock' collapsible>
                        <TimeBank banks={active_user.account.value.timeBanks} />
                    </Card>
                </RequireFeature>
                : null}

        </>
    );
}

export default Wallet;


// const [cardNum, setCardNum] = useState('');
// <Forms
// inputs={{
//     cardNumber: cardNum,
// }}
// onSubmit={(e) =>
//     HamQuest.GetQuery(QuestRoute.giftCard.balance, {
//         cardNumber: e.cardNumber
//     })
//         .then(res => Modal.Show({
//             title: site_config.cardName + ' Balance',
//             body:
//                 <Col>
//                     <div>Status: {res.testMessage}</div>
//                     <div>Balance: {currency.format(res.balance ?? 0)}</div>
//                 </Col>
//         }))
// }
// submitbutton='Check'
// row
// >
// <Input
//     label='Check Balance'
//     name='cardNumber'
//     mask={Regex.mask.creditCard}
//     sanitize={Regex.match.notNumbers}
//     maxLength={19}
//     validate={Regex.test.creditCard}
//     required
// />
// </Forms>

// <MLTextReader
// update={setCardNum}
// pattern={/\d{16}/g}
// confirmation='Is this your card?'
// >Take a photo of your Gift Card</MLTextReader>